interface BrandMarkProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const TEXT_SIZE = {
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-2xl',
};

const TILE_SIZE = {
  sm: 'h-7 w-7 text-sm',
  md: 'h-8 w-8 text-base',
  lg: 'h-10 w-10 text-xl',
};

export function BrandMark({ size = 'md', className = '' }: BrandMarkProps): JSX.Element {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span
        className={`${TILE_SIZE[size]} grid place-items-center rounded-xl bg-gradient-to-br from-honey-400 to-ember-500 text-ink-950 font-extrabold shadow-[inset_0_1px_0_rgba(255,255,255,0.4),0_4px_16px_-6px_rgba(0,240,255,0.55)]`}
        aria-hidden
      >
        速
      </span>
      <span className={`font-display font-extrabold tracking-tight text-white whitespace-nowrap ${TEXT_SIZE[size]}`}>
        速通{' '}
        {/* Hide the "SpeedRun" suffix on tiny screens to keep the brand on one line. */}
        <span className="hidden sm:inline text-cream-400 font-medium">SpeedRun</span>
      </span>
    </span>
  );
}
